import axios from 'axios'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
import { messages } from 'vee-validate/dist/locale/es.json'
import * as rules from 'vee-validate/dist/rules'
import Vue from 'vue'
import { dateCompare } from './rules/date-compare'

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);


//setInteractionMode('eager');

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  });
});

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target;
  },
  message: 'Las contraseñas no coinciden'
});

extend('noBeforeToday', {
  validate (value) {
    const today = new Date().toISOString().split(/[T ]/i, 1)[0];
    return value >= today;
  },
  message: 'La fecha no puede ser anterior al día de hoy'
});

extend(
  'dateFromIsValid',
  {
    validate: (value, {compare}) => {
        return dateCompare(value, compare, 'fromDateIsValid');
    },
    params: ['compare', 'dateType'],
    message: 'La hora deber ser menor'
  }
);

extend(
  'dateToIsValid',
  {
    params: ['compareDate'],
    validate: (value, {compareDate}) => {
      return dateCompare(value, compareDate, 'toDateIsValid');
    },
    message: 'La hora deber ser mayor'
  }
);

extend('web', {
  params: ['target'],
  validate (value) {
      const regex = RegExp('(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+@]*)*(\\?[;&a-z\\d%_.~+=-@]*)?(\\#[-a-z\\d_@]*)?$', 'i');
      return value.match(regex);
  },
  message: 'Web no valida'
});
const slugUnique = (value, args) => {
  return axios.post(`${process.env.VUE_APP_ROOT_API  }/webadmin/restaurants/existslug/${  args.target  }`, { slug : value })
    .then((response) => {
      return true;
    })
    .catch(error => {
      return 'Debe ser un slug único';
    });
};
extend('slugRestaurant', {
  params: ['target'],
  validate: slugUnique
});

extend('minLength', {
  validate (value, args) {
    return value.length >= args.length;
  },
  params: ['length'],
  message: 'Debe contener almenos {length} caracteres'
});

extend('checkDate', {
    validate: (value, {toDate}) => {
      const d1 = Date.parse(value);
      const d2 = Date.parse(toDate);
      return d1 <= d2 && d1 !== '' && d2 !== '';
    },
    params:['toDate'],
    message: 'La fecha final no puede ser antes que la de inicio'
  }
);
extend('whitespace', {
  validate (value) {
    return !/\s/g.test(value);
  },
  message: 'No puede contener espacios en blanco'
});
